export default class ApiTokensTable {

  constructor() {
    this.table = document.querySelector('#grid_api_tokens');

    if (this.table) {
      const self = this;
      this.toggles = this.table.querySelectorAll('.toggle-btn');

      if ( this.toggles.length ) {
        this.toggles.forEach(toggle => {
          toggle.addEventListener('change', self.toggleEnableLabel.bind(this, toggle));
        });
      }

      window.solodev.resetAPIToken = (config) => {
        const resetButton = this.table.querySelector('#' + config.element_id);
        resetButton.addEventListener('click', this.onClickResetToken.bind(this, resetButton));
      }
    }
  }

  toggleEnableLabel(toggle) {
    const row = toggle.closest('tr');
    const label = row.querySelector('.badge');

    const state = {
      color: toggle.checked ? 'green' : 'orange',
      label: toggle.checked ? 'Active' : 'Inactive',
    }

    label.innerText = state.label;
    label.className = 'badge badge-' + state.color;
  }

  onClickResetToken(button) {
    const { url } = button.dataset;

    const row = button.closest('tr');
    const tokenCol = row.querySelector('.token span');

    button.disabled = true;

    $.ajax({
      url,
      type: 'post',
      dataType: 'json',
      success: function(response) {
        tokenCol.dataset.token = response.new_token;

        const icon = row.querySelector('.toggle-token-visibility i');
        if (icon.classList.contains('fa-eye-slash')) {
          tokenCol.innerText = response.new_token;
        }

        button.disabled = false;
      },
      error: function() {
        button.disabled = false;
        $.toast({
          heading: 'Error',
          text: 'Unable to reset this token, please try again later',
          icon: 'error',
          hideAfter: 10000
        });
      }
    });
  }
}
